import { render } from "./Bonus.vue?vue&type=template&id=09595312&scoped=true"
import script from "./Bonus.vue?vue&type=script&lang=js"
export * from "./Bonus.vue?vue&type=script&lang=js"

import "./Bonus.vue?vue&type=style&index=0&id=09595312&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09595312"]])

export default __exports__